var _circle, _path, _path2, _path3, _rect, _line, _line2, _line3, _line4, _ellipse, _line5, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEchoNoteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "#1976d2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 45 80 Q 35 100 45 120",
    stroke: "#ffffff",
    strokeWidth: 8,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 70 Q 50 100 60 130",
    stroke: "#ffffff",
    strokeWidth: 8,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 75 60 Q 65 100 75 140",
    stroke: "#ffffff",
    strokeWidth: 8,
    strokeLinecap: "round",
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 65,
    width: 50,
    height: 70,
    rx: 4,
    fill: "#ffffff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 80,
    x2: 128,
    y2: 80,
    stroke: "#1976d2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 93,
    x2: 128,
    y2: 93,
    stroke: "#1976d2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 106,
    x2: 115,
    y2: 106,
    stroke: "#1976d2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: 119,
    x2: 128,
    y2: 119,
    stroke: "#1976d2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 50,
    rx: 7,
    ry: 10,
    fill: "#FFD700"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 60,
    x2: 110,
    y2: 68,
    stroke: "#FFD700",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 80 Q 165 100 155 120",
    stroke: "#ffffff",
    strokeWidth: 8,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 140 70 Q 150 100 140 130",
    stroke: "#ffffff",
    strokeWidth: 8,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 125 60 Q 135 100 125 140",
    stroke: "#ffffff",
    strokeWidth: 8,
    strokeLinecap: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEchoNoteLogo);
export default __webpack_public_path__ + "static/media/EchoNoteLogo.974d37d94b42b47dc09d38845ee1a972.svg";
export { ForwardRef as ReactComponent };